import {Fancybox} from '@fancyapps/ui'
export function initSolution() {
  const btnSolution = document.querySelector('.js-btn-solution')

  if (!btnSolution) {
    return
  }

  btnSolution.addEventListener('click', (event) => {
    event.stopPropagation()
    event.preventDefault()

    const images = JSON.parse(window.tabs[btnSolution.dataset.tabId].imagesJson).map(image => {
      return {
        src: '/image/' + image.image,
        type: 'image'
      }
    })

    new Fancybox(images, {
      touch: {
        vertical: true, // Allow to drag content vertically
        momentum: true // Continue movement after releasing mouse/touch when panning
      },
    })
  })
}
